/**Packages */
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

/**Components */
import TextLink from "../../Elements/TextLink";
import FlexRow from "../../Elements/FlexRow";

/**Helpers */
import { PAGES } from "../../../helpers/constants";
import NavigationProvider from "../../../providers/NavigationProvider";

/**CSS */
import "./style.css";

const Footer = () => {
    const { t, i18n, ready } = useTranslation();
    const isLogged = useSelector((state) => state?.user?.isLoggedIn);

    return (
        <footer id="layout-footer" className="background-gray-dark">
            <FlexRow id="footer-first-row" classList="xs cols-equal">
                <div className="cpar-flex-col">
                    <TextLink
                        onClick={() => {
                            NavigationProvider.goTo(isLogged ? PAGES.USER_AREA.USER_ONLINE_SECURITY : PAGES.ONLINE_SECURITY);
                        }}
                        text={t("Sicurezza online")}
                    />
                </div>
                <div className="cpar-flex-col">
                    <TextLink
                        onClick={() => {
                            NavigationProvider.goTo(isLogged ? PAGES.USER_AREA.USER_USEFUL_NUMBERS : PAGES.USEFUL_NUMBERS);
                        }}
                        text={t("Numeri utili per assistenza")}
                    />
                </div>
            </FlexRow>
            <FlexRow id="footer-second-row" classList="lg">
                <p className="text-size-xs">
                    Compass Banca S.p.A., Gruppo Bancario Monte dei Paschi di Siena iscritto all’Albo dei Gruppi Bancari al n. 1030, socio unico Mediobanca S.p.A. Direzione e Coordinamento Banca Monte
                    dei Paschi di Siena S.p.A. Partita IVA Gruppo IVA Mediobanca: 10536040966; C.F N. iscr. R.I. di Milano 00864530159. Tutti i diritti riservati -{" "}
                    <a href="https://compass.it/dati-societari-compass-spa.html">Dati Societari</a> - Messaggio pubblicitario con finalità promozionale. Documenti informativi disponibili sul sito
                    Compass, presso le Filiali Compass Banca S.p.A. o presso le Agenzie Autorizzate. <b>L'esito definitivo</b> viene comunicato entro il termine della giornata lavorativa successiva,
                    rispetto al momento in cui è stata fornita la documentazione completa. Nel caso in cui questa venga fornita in un giorno festivo,sabato incluso, si considera come pervenuta il
                    primo giorno lavorativo successivo, salvo approvazione di Compass Banca S.p.A.
                </p>
            </FlexRow>
        </footer>
    );
};
export default Footer;
